import { render, staticRenderFns } from "./likeList.vue?vue&type=template&id=63f3ec63&"
import script from "./likeList.vue?vue&type=script&lang=js&"
export * from "./likeList.vue?vue&type=script&lang=js&"
import style0 from "./likeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports